import avatarModule from '../avatarModule';
/*
    Controls the type section of the avatar page, which lets you switch between the R6 rig and the R15 rig
    Receives updates about avatar type changes through the avatarDetailsLoaded event
*/

function avatarTypeController($scope, avatarService, avatarConstantService) {
  'ngInject';

  $scope.avatarType = avatarConstantService.avatarType.defaultOnPageLoad;
  $scope.avatarTypes = avatarConstantService.avatarType.avatarTypes;

  function updateScalingEnabled() {
    $scope.avatarDataModel.scaleEnabled = $scope.avatarType === 'R15';
  }

  $scope.updateAvatarType = function() {
    const { avatarType } = $scope;
    updateScalingEnabled();

    avatarService.setAvatarType(avatarType).then(
      function(result) {
        $scope.refreshThumbnail();
      },
      function() {
        $scope.systemFeedback.error(avatarConstantService.avatarType.failedToUpdate);
      }
    );
  };

  $scope.$on(avatarConstantService.events.avatarDetailsLoaded, function(event, avatarDetails) {
    $scope.avatarType = avatarDetails.playerAvatarType;
    updateScalingEnabled();
  });
}

avatarModule.controller('avatarTypeController', avatarTypeController);

export default avatarTypeController;
